import { PushArticlesBlogB2c } from '@components/push-articles-blog-b2c/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const pushArticlesBlogB2cMock: Block<PushArticlesBlogB2c> = {
  type: 'push-articles-blog-b2c',
  data: {
    title: {
      text: 'Pour épater votre Kitchener, découvrez [[tous nos conseils !]]',
      as: 'span',
    },
    articles: [
      {
        image: imageMock,
        url: '/mock-blog-b2c/entretien-hotte',
        category: 'Électroménager',
        date: '28/01/2024',
        title: 'Comment bien entretenir sa hotte sur le long terme ?',
      },
      {
        image: imageMock,
        url: '/mock-blog-b2c/plan-travail-quartz-avantages',
        category: 'Style',
        date: '24/10/2024',
        title: 'Plan de travail en quartz pour ma cuisine : quels avantages ?',
      },
      {
        image: imageMock,
        url: '/mock-blog-b2c/nettoyage-plaque-cuisson',
        category: 'Électroménager',
        date: '28/01/2024',
        title: 'Comment nettoyer efficacement une plaque de cuisson en verre ?',
      },
    ],
  },
};
